/* iter55g60 — Token cost heuristics hook.
 *
 * Centralises the per-action token estimates (Continue / Draft chapter
 * / Tone shift) and whether the writer's remaining balance covers
 * them. EditorPanel used to inline these calls; extracting them keeps
 * the panel focused on composition.
 */
import { useMemo } from 'react';
import {
  chapterTokens,
  continueTokens,
  toneShiftTokens,
  tokensRemaining,
} from '@/lib/tokenEstimate';

export function useTokenCostHeuristics({ project, tokens }) {
  return useMemo(() => {
    const wpc          = project?.words_per_chapter || 2500;
    const remaining    = tokensRemaining(tokens);
    const continueCost = continueTokens();
    const draftCost    = chapterTokens(wpc);
    const toneCost     = toneShiftTokens();
    return {
      wpc,
      remaining,
      continueCost,
      draftCost,
      toneCost,
      enoughForContinue: remaining >= continueCost,
      enoughForDraft:    remaining >= draftCost,
      enoughForTone:     remaining >= toneCost,
    };
  }, [project?.words_per_chapter, tokens]);
}
